import { Device } from '../devices/Device';
export function autoDetectAntialias() {
    return Device.desktop;
}
